// eslint-disable-next-line import/no-anonymous-default-export
export default {
	api_base: "https://api.rpd.ink/api"
}
